'use client'

export default function NotFound() {
  return (
    <div>
      <h1>Die Seite konnte nicht gefunden werden.</h1>
    </div>
  )
}
